const doc = [({"se":({"js":({"routes":({"user":({"courses":({"show":({"the_class_have_started_the_course":"Klassen har börjat kursen"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;